import { NavLink } from "react-router-dom"
import { useAuthContext } from "../hooks/useAuthContext"
import { useLogout } from '../hooks/useLogout'
//import { Reload } from './Reload'

// styles
import styles from './Navbar.module.css'
import './Navbar.css'

export default function Navbar() {
  const { logout } = useLogout()
  const { user } = useAuthContext()
  // const { reload } = Reload()

  // nn128

  return (
    <nav className={styles.navbar}>
      <ul>
        <li className={styles.title}>Shopping List Guru v4f
        </li>

        {!user && (
          <>
            <li><NavLink to="/login">Login</NavLink></li>
            <li><NavLink to="/signup">Signup</NavLink></li>
            <li><NavLink to="/helpbg">Help</NavLink></li>
          </>
        )}

        {user && (
          <>
            <li>hello, {user.displayName}</li>
            <li>
              {/* <Link to="/reload">Reload</Link> */}
              <NavLink to="/help">Help</NavLink>

              {/* <button className="btn" onClick={reload}>Reload2</button> */}
              {/* <button className="btn">Reload1</button> */}
              {/* <button className="btn">Help</button> */}
              <button className="btn" onClick={logout}>Logout</button>
            </li>
          </>
        )}
      </ul>
    </nav>
  )
}
